export const COPYRIGHT = 'Virgin Media. All Rights Reserved';
export const LOGO_URL = 'https://www.virginmedia.com';
export const LOGO_ALT = '"Virgin Media logo';
export const LOGO_WIDTH = 54;
export const LOGO_HEIGHT = 33;
export const LOGO_MIME = 'image/png';
